export interface StoredTile {
  roomId: string
  tileX: number
  tileY: number
  tileType: 'room' | 'outline'
}

export interface UnsavedTileChange {
  roomId: string
  tileX: number
  tileY: number
  tileType: 'room' | 'outline'
  operation: 'create' | 'update' | 'delete'
}

/**
 * The tiles as the admin sees them: the stored tiles with the unsaved changes applied (a create or
 * update puts the tile in, a delete takes it out). Tiles are painted up to 30 s before they are
 * stored, and a VR switch redraws the outlines from storage, so without this an unsaved tile would
 * lose its outline until the next save. The stored list is not changed.
 */
export function overlayUnsavedTiles(stored: StoredTile[], unsaved: UnsavedTileChange[]): StoredTile[] {
  if (unsaved.length === 0) return stored

  const keyOf = (tile: { roomId: string; tileX: number; tileY: number }) =>
    `${tile.roomId}_${tile.tileX}_${tile.tileY}`
  const tiles = new Map<string, StoredTile>()
  for (const tile of stored) tiles.set(keyOf(tile), tile)
  for (const change of unsaved) {
    if (change.operation === 'delete') {
      tiles.delete(keyOf(change))
    } else {
      tiles.set(keyOf(change), {
        roomId: change.roomId,
        tileX: change.tileX,
        tileY: change.tileY,
        tileType: change.tileType,
      })
    }
  }
  return Array.from(tiles.values())
}
